
import { Options, Vue } from 'vue-class-component';
import * as OM from '@/Model';
import BaseServerFilterTable from '@/components/customTable/baseServerFilterTable';
import { Prop, Watch } from 'vue-property-decorator';
import store from '@/store';

@Options({
    components: {
    }
})
export default class chatListComponent extends BaseServerFilterTable {

    @Prop() userIdentifier;
    @Prop() initCallback;

    list: OM.BackofficeChatListVM[] = [];
    lang: string = store.state.loggedUser.preferredCulture;
    ghostingLevels = OM.GhostingLevel;

    created() {
    }

    init = function(){
        var tempRequestFilter = this.requestFilter;

        if(this.userIdentifier)
            tempRequestFilter.identifier = this.userIdentifier;

        this.initCallback(tempRequestFilter, this.setPagedResponse);
    }

    setPagedResponse(pagedResponse: OM.PagedResponseOfBackofficeChatListVM){
        this.totalItems = pagedResponse.totalItemsCount;
        this.list = pagedResponse.items;
    }

    rowClicked(identifier: string){
        this.$emit("rowClicked", identifier);
    }

    getNames(vm: OM.BackofficeChatListVM){

        var appUsers = vm.subscribers.map( x => x.profileName);

        var result = "";
        for(var i = 0; i < appUsers.length; i++){
            result += appUsers[i];

            if(i < appUsers.length - 1)
                result += " - ";
        }

        return result;
    }
}
